export const ADD_MUSICIAN_ADDITIONAL_DOCS = 'ADD_MUSICIAN_ADDITIONAL_DOCS' // get from api & push that to redux store